import { Box, Typography } from '@mui/material';
import { ResultsListItem } from '../../../../possibly-stateful-components/Results/ResultsListItem.tsx';
import { FavoriteProperties } from '../../../../models/favorites.model.ts';
import { PropertySearchResTypeData } from '../../../../services/api';

interface ResultsListProps {
  favorites: PropertySearchResTypeData[];
}

export const ResultsList = ({ favorites }: ResultsListProps) => {
  return (
    <Box>
      {favorites && favorites?.length > 0 ? (
        <>
          <Typography variant="h1" className="header" data-home-page-title>
            Favorites Home on Land
          </Typography>
          <Box className="results-list">
            {favorites.map((result) => {
              if (result === undefined) return null;
              return (
                <Box key={result.id} sx={{ maxWidth: '350px' }}>
                  {result && (
                    // TODO: Fix the type casting here, it should not be necessary
                    <ResultsListItem
                      favorites={favorites as never as FavoriteProperties[]}
                      result={result}
                      showmoveForward
                    />
                  )}
                </Box>
              );
            })}
          </Box>
        </>
      ) : null}
    </Box>
  );
};
